const candidateNotes = {
    firestoreRefType: 'collection',
    firestorePath: 'candidates/{candidateID}/notes',
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    moduleName: 'candidate_notes',
    statePropName: 'notes',
    // the rest of your module here
}
// add userModule as vuex plugin wrapped in vuex-easy-firestore

export default candidateNotes